import { H2, MainWrapper } from "@/lib/styles";
import styled from "styled-components";

export const OpenPositionsContainer = styled(MainWrapper)`
  padding-top: 100px;
  padding-bottom: 80px;
`;

export const PageHeading = styled(H2)`
  padding-bottom: 100px;
`;

export const OpenPositionsList = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 240px;
`;
